"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import type { FC } from "react";

// bgColor is the game's letterboxing accent, not a scrim for a full-viewport overlay.
const FullscreenBackdrop: FC = () => {
  const { isFullscreen } = useGamePageData();

  if (!isFullscreen) return null;

  return (
    <div
      aria-hidden="true"
      data-testid="fullscreen-backdrop"
      className="fixed inset-0 z-[997] bg-black"
    />
  );
};

export default FullscreenBackdrop;
